module.exports = __webpack_public_path__ + "img/printingAct.fcda3090.png";